import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../bmr/services/api/axios.config";

const initialState = {
  isLoading: false,
  validationOptions:[],
  validationData:[]
}

// Adding here PropertyTab
export const getValidationOptions = createAsyncThunk(
  'bmr/getValidationOptions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/ftb/templates/sections/fields/validations`);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Adding validation API here
export const submitValidation = createAsyncThunk(
  'bmr/submitValidation',
  async ({ fieldId, validation }, { rejectWithValue }) => {
    try {
      const response = await api.put(`ftb/templates/sections/fields/${fieldId}/validations`, validation);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Adding validation API here
export const getAddedValidation = createAsyncThunk(
  'bmr/getAddedValidation',
  async ({ fieldId }, { rejectWithValue }) => {
    try {
      const response = await api.get(`ftb/templates/sections/fields/${fieldId}/validations`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

const bmrFbShadowSlice = createSlice({
  name: 'bmrFbShadow',
  initialState,
  reducers: {
 
  },
  extraReducers: (builder) => {
    builder  
           
      // @info validation part start here
      .addCase(getValidationOptions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getValidationOptions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.validationOptions=action.payload
      })
      .addCase(getValidationOptions.rejected, (state) => {
        state.isLoading = false;
      })     
      // @info getValidation of the fields 
      .addCase(submitValidation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(submitValidation.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(submitValidation.rejected, (state) => {
        state.isLoading = false;
      })

      //@info get added validation of the type of fields.
      .addCase(getAddedValidation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAddedValidation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.validationData=action.payload.data
      })
      .addCase(getAddedValidation.rejected, (state) => {
        state.isLoading = false;
      })      
  }
});

export default bmrFbShadowSlice.reducer;
